import { useAuth0 } from '@auth0/auth0-react';
import LockResetIcon from '@mui/icons-material/LockReset';
import { Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
export const UserAuthCard = () => {
  const { user } = useAuth0();
  return (
    <Paper sx={{ p: 4, minWidth: '30%', flexShrink: 0 }}>
      <Typography variant={'h6'} mb={2}>
        Přihlašovací údaje
      </Typography>
      <Stack>
        <TextField
          variant={'standard'}
          InputProps={{ readOnly: true, disableUnderline: true }}
          label={'E-mail'}
          value={user?.email}
          fullWidth
        />
      </Stack>
      <Box mt={4}>
        <Button component={Link} to={'reset-password'} variant={'outlined'} startIcon={<LockResetIcon />} fullWidth>
          Změnit heslo
        </Button>
      </Box>
    </Paper>
  );
};
